import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './SearchSelector_BaseManagerUI.scss';
import { resolveContent } from '@nu-art/ts-common';
import { Component_SearchAndResults } from '../../search-v2/Component_SearchAndResults.js';
export class SearchSelector_BaseManagerUI extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.selectedItem = nextProps.selectedItem;
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { id: 'search-selector', children: [_jsx(LL_H_C, { className: 'button-container', children: this.props.buttons.map((data, i) => {
                        return _jsx(Button, { variant: 'primary', className: 'btn-create preferred-action', onClick: data.action, children: resolveContent(data.label) }, i);
                    }) }), _jsx(Component_SearchAndResults, { searchItems: this.props.searchItems, selectedItem: this.props.selectedItem, onSearchItemSelected: this.props.onSearchItemSelected, getRightClickActions: this.props.getRightClickActions })] });
    }
}
//# sourceMappingURL=SearchSelector_BaseManagerUI.js.map